export const services = [
    {
        id: "detailing",
        name: "Detailing",
        problem: "Daily driving builds up contamination, dullness and interior wear that a regular wash never touches.",
        solution: "Deep, correction-grade detailing inside and out.",
        result: "A cabin and finish that feel closer to the day the car was delivered.",
        image: "/assets/work/work-detailing-polish.webp",
        alt: "Real Revautoz work — technician machine-polishing a headlight and fender with a dual-action polisher",
        placeholder: false,
    },
    {
        id: "ppf",
        name: "PPF",
        problem: "Road debris, stone chips and everyday exposure damage vulnerable painted panels first.",
        solution: "Precision-installed paint protection film on high-impact and high-value areas.",
        result: "A self-healing barrier designed to help preserve the factory finish beneath.",
        image: "/assets/work/ppf-installation.webp",
        alt: "Real Revautoz work — technicians precision-installing paint protection film on a Kia Seltos bonnet",
        placeholder: false,
    },
    {
        id: "ceramic",
        name: "Ceramic",
        problem: "Unprotected paint loses gloss, holds dirt and demands constant effort to keep clean.",
        solution: "Professional ceramic coating bonded over corrected paintwork.",
        result: "Lasting gloss, hydrophobic behaviour and noticeably easier maintenance.",
        image: "/assets/work/ceramic-application.webp",
        alt: "Real Revautoz work — technician applying ceramic coating to a black SUV panel by hand",
        placeholder: false,
    },
    {
        id: "restoration",
        name: "Restoration",
        problem: "Faded paint, tired trim and worn interiors quietly age a vehicle beyond its years.",
        solution: "Systematic restoration of paint, panels and interior surfaces.",
        result: "Presence and finish returned toward the standard the car left with.",
        image: "/assets/work/work-restoration-prep.webp",
        alt: "Real Revautoz work — technician refinishing a masked panel during bodywork restoration",
        placeholder: false,
    },
    {
        id: "custom",
        name: "Custom",
        problem: "A stock vehicle rarely reflects the person driving it.",
        solution: "Bespoke interiors, body kits, wheels, lighting and accessories to your specification.",
        result: "A car that carries your signature, built to a premium standard.",
        image: "/assets/work/custom-interior-thar.webp",
        alt: "Real Revautoz work — technicians retrimming a Mahindra Thar Roxx interior in black leather with red stitching",
        placeholder: false,
    },
    {
        id: "bodyshop",
        name: "Bodyshop",
        problem: "Dents, accident damage and panel wear demand more than cosmetic cover-ups.",
        solution: "Denting, painting, panel repair and refinishing in-house.",
        result: "Factory-level panel fit and paint match, inspected before handover.",
        image: "/assets/work/bodyshop-paint.webp",
        alt: "Real Revautoz work — technician spray-painting a masked SUV panel inside the Revautoz bodyshop",
        placeholder: false,
    },
];

export const serviceOptions = [
    "Free Inspection",
    "Detailing",
    "PPF",
    "Ceramic",
    "Paint Correction",
    "Restoration",
    "Custom",
    "Bodyshop",
    "Not sure",
];
